import { useState } from "react";
import { PageHeader } from "../molecules/PageHeader";
import { StatsGrid } from "../organisms/StatsGrid";
import { DataTable } from "../organisms/DataTable";
import { FilterButton } from "../atoms/FilterButton";


import {
    EVENTS_STATS,
    EVENT_TABLE_HEADERS,
    type Event,
    MOCK_EVENTS,

} from "@/data/events.data";

const EventTableRow = ({ event }: { event: Event }) => (
    <tr className="border-b border-dark-30 hover:bg-dark-30 transition-colors">
        <td className="px-6 py-4 text-dark-text font-medium">{event.eventID}</td>
        <td className="px-6 py-4 text-dark-text">{event.title}</td>
        <td className="px-6 py-4 text-dark-text">{event.type}</td>
        <td className="px-6 py-4 text-dark-text">{event.host}</td>
        <td className="px-6 py-4 text-dark-text">{event.participants}</td>
        <td className="px-6 py-4 text-dark-text">{event.date}</td>
        <td className="px-6 py-4 text-dark-text">{event.location}</td>
        <td className="px-6 py-4">
            <span className="inline-flex px-2 py-1 rounded text-sm text-dark-text">
                {event.status}
            </span>
        </td>
    </tr>
);



const Events = () => {

    const [currentPage, setCurrentPage] = useState(1);



    return (
        <div className="max-w-7xl mx-auto space-y-10">
            <PageHeader title="Scheduling & Events Monitor" />
            <StatsGrid stats={EVENTS_STATS} columns={2} />
            <DataTable
                title="Scheduled Events"
                headers={EVENT_TABLE_HEADERS}
                data={MOCK_EVENTS}
                renderRow={(event) => (
                    <EventTableRow key={event.id} event={event} />
                )}
                filters={
                    <>
                        <FilterButton label="Type" />
                        <FilterButton label="Status" />
                        <FilterButton label="Date Range" />
                    </>
                }
                currentPage={currentPage}
                onPageChange={setCurrentPage}
            />
        </div>
    )
}

export default Events